import AddRemoveSelectFields from './form/add-remove-select-fields';
import Address from './form/address';
import CountryCheck from './form/country-check';
import CheckboxOtherInputs from './form/checkbox-other-inputs';
import DropdownOtherInputs from './form/dropdown-other-inputs';
import DropdownSelectChange from './form/dropdown-select-change';
import EventDelegates from './form/event-delegates';
import FieldUnlock from './form/field-unlock';
import FileUploadPreview from './form/file-upload-preview';
import FormWrapper from './form/form-wrapper';
import Loqate from './form/loqate';
import InstitutionOptOut from './form/institution-opt-out';
import InstitutionReminder from './form/institution-reminder';
import PaymentMethodCheck from './form/payment-method-check';
import RequiredSubmitCheck from './form/required-submit-check';
import StudentFields from './form/student-fields';
import StudentFieldValidation from './form/student-field-validation';
import UnmatchCheck from './form/unmatch-check';

class Form {
    constructor () {
        // Add and remove select fields in profile templates
        // -----------------------------
        // - Interests
        // - Other memberships
        new AddRemoveSelectFields();

        // Address fields - Manually enter address.
        // -----------------------------
        // - Account creation - Address
        new Address();

        // Show the State field if the country string is America
        // -----------------------------
        // - List of supports strings in the module
        // - Account Creation - Address
        // - Edit Profile - Address
        // - Event Reg - Address (all of them!)
        new CountryCheck();

        // Checkbox Other Inputs
        // - Account creation - Early Career Researcher post grad date
        // -----------------------------
        new CheckboxOtherInputs();

        // Dropdown Other Inputs
        // - Event delegates
        // -----------------------------
        new DropdownOtherInputs();

        // Dropdown Select Change
        // - Edit Profile
        // -----------------------------
        new DropdownSelectChange();

        // Event Delegates
        // - Add / Remove delegates
        // -----------------------------
        new EventDelegates();

        // Field Unlock Button
        // -----------------------------
        // - Account Creation - institution not listed button
        // - Edit Profile - institution not listed button
        // - Event Reg - booker and delegate institution not listed buttons
        new FieldUnlock();

        new FileUploadPreview();

        // Form Wrapper
        // -----------------------------
        // - Dealing with outer form wrapper on event registration form
        new FormWrapper();

        // Institution Opt Out Functionality
        // -----------------------------
        // - Account Creation - institution opt out button
        // - Edit Profile - institution opt out button
        // - Event Reg - booker and delegate institution opt out buttons
        new InstitutionOptOut();

        // Institution Reminder
        // -----------------------------
        // - Edit Profile
        new InstitutionReminder();

        // Loqate / PCA Predict / PostcodeAnywhere
        new Loqate();

        // Payment Method Check
        // - Event Reg - If invoice selected, show extra fields
        // -----------------------------
        new PaymentMethodCheck();

        // Required field check on submit
        // -----------------------------
        new RequiredSubmitCheck();

        // Student Fields Toggle
        // -----------------------------
        // - Renew Form, if student membership selected - show extra fields
        new StudentFields();

        // Student Validation
        // -----------------------------
        // - Renew Form, check student has checked the acknowledgment and added a grad date
        new StudentFieldValidation();

        // Check values don't match
        // - Event Reg form, check each delegate email is unique.
        // -----------------------------
        new UnmatchCheck();
    }
}

export default Form;
